export const theme = {
    fontFamily: "font-family: 'Poppins', sans-serif",
    // colorPrimary: ,
    bgContent : "#E8E6E1",
    borderRadius: 8,
    bgSideBar : "#11375C",
    boxShadow: "0px 0px 16px rgba(0, 0, 0, 0.1)"
}